<div style="height: calc(100vh - 92px - 20px - 40px);">
  <div class="button-row">
    <!--<button type="button" pButton class="apikey-list-button" icon="fa fa-refresh" label="Refresh"
  (click)="refreshApiKeys()"></button>-->

  <button [disabled]="!isLicenseValid" type="button" pButton class="apikey-list-button" icon="fa fa-plus-square-o"
  label="Create API Key" (click)="createApiKey()"></button>
</div>

<p-table #dt [value]="entries" [resizableColumns]="true"
  [scrollable]="true" scrollHeight="calc(100vh - 92px - 20px - 48px - 60px - 40px + 6px)"
  [customSort]="true" (sortFunction)="doCustomSort($event)">

  <ng-template pTemplate="header">
    <tr>
      <th pResizableColumn pSortableColumn="name">
        Name
        <p-sortIcon field="name"></p-sortIcon>
      </th>
      <th pResizableColumn pSortableColumn="active">
        Active
        <p-sortIcon field="active"></p-sortIcon>
      </th>
      <th pResizableColumn pSortableColumn="guid" [ngStyle]="{'width':'300px'}">
        API Key
        <p-sortIcon field="guid"></p-sortIcon>
      </th>
      <th pResizableColumn pSortableColumn="owner">
        Owner
        <p-sortIcon field="owner"></p-sortIcon>
      </th>
      <th pResizableColumn pSortableColumn="lastActivity">
        Last Activity
        <p-sortIcon field="lastActivity"></p-sortIcon>
      </th>
      <th [ngClass]="{'uv-table-button-column-3': isAdmin, 'uv-table-button-column-2': !isAdmin}">
      </th>
    </tr>

    <tr>
      <th>
        <input pInputText type="text" (input)="dt.filter($event.target.value, 'name', 'contains')"
          style="width: 100%;">
        </th>
        <th>
          <input pInputText type="text" (input)="dt.filter($event.target.value, 'active', 'contains')"
            style="width: 100%;">
          </th>
          <th [ngStyle]="{'width':'300px'}">
            <input pInputText type="text" (input)="dt.filter($event.target.value, 'guid', 'contains')"
              style="width: 100%;">
            </th>
            <th>
              <input pInputText type="text" (input)="dt.filter($event.target.value, 'owner', 'contains')"
                style="width: 100%;">
              </th>
              <th>
                <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastActivity', 'contains')"
                  style="width: 100%;">
                </th>
                <th  [ngClass]="{'uv-table-button-column-3': isAdmin, 'uv-table-button-column-2': !isAdmin}">
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              <tr [pSelectableRow]="rowData">
                <td>
                  <span class="uv-table-value">{{rowData.name}}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{rowData.active}}</span>
                </td>
                <td [ngStyle]="{'width':'300px'}">
                  <span class="uv-table-value">{{rowData.guid}}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{rowData.owner}}</span>
                </td>
                <td>
                  <span class="uv-table-value">{{rowData.lastActivity}}</span>
                </td>
                <td [ngClass]="{'uv-table-button-column-3': isAdmin, 'uv-table-button-column-2': !isAdmin}">
                  <button [disabled]="!isLicenseValid" class="btn btn-primary uv-first-table-button"
                    title="Edit this API key" (click)="editApiKey(rowData.tag)">
                    <i class="fa fa-edit"></i>
                  </button>
                  @if (isAdmin) {
                    <button class="btn btn-primary uv-table-button" title="Change this API key's owner"
                      [disabled]="!isLicenseValid" (click)="onTransferClick($event, rowData.tag)">
                      <i class="fa fa-exchange"></i>
                    </button>
                  }
                  <button [disabled]="!isLicenseValid" class="btn btn-danger uv-table-button" title="Delete this API key"
                    (click)="deleteApiKey(rowData.tag)">
                    <i class="pi pi-trash"></i>
                  </button>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <apikey-dialog [(visible)]="apiKeyDialogVisible" [target]="apiKeyDialogTarget" [create]="apiKeyDialogCreate"
          (onOk)="onApiKeyOkClicked($event)" (onCancel)="onApiKeyCancelClicked()"></apikey-dialog>

          <confirmation-dialog message="Are you sure you want to delete this API key?"
            [display]="displayDeleteApiKeyConfirm"
            (onYes)="onDeleteOkClicked()" (onNo)="onDeleteCancelClicked()">
          </confirmation-dialog>

          <user-selector header="Select new API key owner" [(visible)]="displayUserSelectorDialog" [minUsers]="1" [maxUsers]="1"
            [except]="xferUserSelectorExceptions" format="full" (onOk)="doApiKeyTransfer($event)"
          (onCancel)="cancelApiKeyTransfer()"></user-selector>

        </div>